import type { OnboardingProgressResponse } from "../api/get-onboarding-progress";

/**
 * Poll/refetch can return jtbd + no gateway before the engine lists a gateway
 * that was just created. Keep the cached connect step instead of regressing.
 */
export function preserveConnectStepOnStaleGatewayRead(
  previous: OnboardingProgressResponse | undefined,
  incoming: OnboardingProgressResponse
): OnboardingProgressResponse {
  if (previous == null || incoming == null) {
    return incoming;
  }

  const staleGatewayRead =
    previous.gateway != null &&
    previous.current_step === "connect" &&
    incoming.gateway == null &&
    incoming.current_step === "jtbd";

  if (!staleGatewayRead) {
    return incoming;
  }

  return {
    ...incoming,
    current_step: "connect",
    gateway: previous.gateway,
  };
}
